'use client';

import Image from 'next/image';

import { cn } from '@eliadmin/core/src/utils/style-utils';

export function InputImage({
  src,
  alt,
  className,
}: {
  src: string;
  alt: string;
  className?: string;
}) {
  return (
    <Image
      src={src}
      alt={alt}
      width={20}
      height={20}
      className={cn('cursor-context-menu', className)}
    />
  );
}
